'use client';

import 'client-only';

import { ToolsPaymentFeature } from '../common/features/tools-payment-feature';
import { createUseFlag } from './create-use-flag';

export const useToolsPaymentFeature = createUseFlag(ToolsPaymentFeature);
